<div class="case-manager-category-result">
  <!--
    The toolbar stays mounted when the organization has no categories yet: the page
    keeps its Create button in that state too, and hiding it here would put Create
    out of reach exactly when it is needed. Search goes, having nothing to filter.
  -->
  <div
    class="case-manager-category-result__toolbar"
    [class.case-manager-category-result__toolbar--end]="!categories().length"
  >
    @if (categories().length) {
      <ui-search
        [placeholder]="'COMMON.SEARCH' | translate"
        [searchQuery]="searchQuery()"
        (onInput)="onSearchQuery($event)"
      ></ui-search>
    }
    <ui-button
      type="primary"
      [text]="'COMMON.CREATE' | translate"
      (clickAction)="create()"
    ></ui-button>
  </div>

  @if (!categories().length) {
    <ui-no-data [imgSrc]="noData.imgSrc" [title]="noData.title | translate"></ui-no-data>
  } @else if (!filteredCategories().length) {
    <ui-no-data [imgSrc]="noResults.imgSrc" [title]="noResults.title | translate"></ui-no-data>
  } @else {
    <div class="case-manager-category-result__table">
      <ui-dataset-table
        [data]="filteredCategories()"
        [config]="tableConfig"
        (rowAction)="onRowAction($event)"
      ></ui-dataset-table>
    </div>
  }
</div>
